/* NFC-boodschap: animatie in het uitleg-blok.
   Zet fasen op <figure data-nfca>; de CSS doet de beweging.
   Loopt rustig in een lus, pauzeert buiten beeld en respecteert prefers-reduced-motion. */
(function () {
"use strict";
const STEPS = [
  [1400, "Een fotomagneet op de koelkast."],
  [1600, "Houd je telefoon ertegen."],
  [2000, "De chip opent de link. Zonder app."],
  [2600, "Er wacht een envelop. Tik op het zegel."],
  [1400, "Het zegel breekt."],
  [3000, "Je hoort de stem."],
  [3200, "Of je ziet een video."],
  [3200, "Of je leest een paar lieve woorden."],
  [1600, "Elke keer weer, zo vaak als je wilt."]
];
const STATIC_CAP = "Telefoon tegen de magneet, envelop open, en je hoort, ziet of leest de boodschap.";

function init(fig) {
  if (fig.dataset.nfcaReady) return; fig.dataset.nfcaReady = "1";
  const cap = fig.querySelector("[data-nfca-cap]"), btn = fig.querySelector("[data-nfca-pause]");
  const mq = window.matchMedia ? window.matchMedia("(prefers-reduced-motion: reduce)") : {matches: false};
  let i = 0, timer = null, paused = false, visible = true;

  const set = n => { i = n; fig.dataset.phase = String(n); cap.textContent = STEPS[n][1]; };
  const stop = () => { clearTimeout(timer); timer = null; };
  const run = () => {
    stop();
    if (paused || !visible || mq.matches) return;
    timer = setTimeout(() => { set((i + 1) % STEPS.length); run(); }, STEPS[i][0]);
  };
  const still = () => { stop(); fig.dataset.phase = "static"; cap.textContent = STATIC_CAP; };

  if (btn) btn.addEventListener("click", () => {
    paused = !paused;
    btn.setAttribute("aria-pressed", String(paused));
    btn.textContent = paused ? "Speel af" : "Pauzeer";
    if (!paused) run(); else stop();
  });
  const apply = () => { if (mq.matches) still(); else { if (fig.dataset.phase === "static") set(0); run(); } };
  if (mq.addEventListener) mq.addEventListener("change", apply);
  if ("IntersectionObserver" in window) {
    new IntersectionObserver(es => es.forEach(e => { visible = e.isIntersecting; if (visible) run(); else stop(); }), {threshold: .2}).observe(fig);
  }
  document.addEventListener("visibilitychange", () => { if (document.hidden) stop(); else run(); });
  if (mq.matches) still(); else { set(0); run(); }
}
function boot() { document.querySelectorAll("[data-nfca]").forEach(init); }
document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", boot) : boot();
document.addEventListener("shopify:section:load", boot);
})();
